// libraries.
import { Form } from 'react-bootstrap';

// styles.
import { StyledPolygonTypeCheckbox } from './styles';

interface PolygonTypeCheckboxProps {
  isChecked: boolean;
  onChange: (polygon_type: 'standard' | 'blocking') => void;
}

export const PolygonTypeCheckbox = ({
  isChecked,
  onChange,
}: PolygonTypeCheckboxProps) => {
  const handleCheckboxChange = (checked: boolean) => {
    onChange(checked ? 'blocking' : 'standard');
  };

  return (
    <StyledPolygonTypeCheckbox>
      <Form.Group className="d-flex flex-column pb-1" controlId="polygonType">
        <Form.Label className="text-start mb-0">Tipo de polígono</Form.Label>
        <Form.Check
          type="checkbox"
          id="blocking-polygon-checkbox"
          label="Marcar como bloqueo"
          checked={isChecked}
          onChange={e => handleCheckboxChange(e.target.checked)}
        />
      </Form.Group>
    </StyledPolygonTypeCheckbox>
  );
};
